/**
 * Loads modules required for the main content matrix
 */

import anchorLinks from '@modules/anchorLinks';
import cookieConsent from '@modules/cookieConsent';
import { loadModulesWhenInView } from '@helpers/loadModule';

export default function init(): void {
  // Load optional modules when in view
  anchorLinks();
  cookieConsent();
  loadModulesWhenInView([
    {
      selector: '.js-accordion-item',
      importer: () => import('@modules/accordion'),
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/formieCsrf') as Promise<Module<HTMLFormElement>>,
    },
    {
      selector: '.fui-form',
      importer: () => import('@modules/gtmFormSubmission') as Promise<Module<HTMLFormElement>>,
    },
    {
      selector: '.js-map',
      importer: () => import('@modules/mapbox') as Promise<Module<HTMLDivElement>>,
      distance: 250,
    },
    {
      selector: '.js-social-share-button',
      importer: () => import('@modules/socialShare') as Promise<Module<HTMLDivElement>>,
    },
    {
      selector: '.js-swiper',
      importer: () => import('@modules/swiper') as Promise<Module<HTMLDivElement>>,
    },
    {
      selector: '.js-video-container',
      importer: () => import('@modules/video') as Promise<Module<HTMLDivElement>>,
    },
  ]);
}
